import React from 'react'
import { Button } from 'react-bootstrap'
import TopTooltip from '_/shared/components/topTooltip'
import EmailRecordModal from '_/shared/components/emailRecordModal'
import FlagRecordModal from '_/shared/components/flagRecordModal'

/**
 * Property page actions
 */
class PropertyActions extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    property: React.PropTypes.object.isRequired,
    handleEdit: React.PropTypes.func,
    editing: React.PropTypes.bool
  }

  render() {
    const { account, property, editing = false, handleEdit } = this.props
    const isPrivate = property.get('isPrivate')
    const isAdmin = account.get('isAdmin')

    const bsStyle = 'link'
    const bsSize = 'small'

    return (
      <div className="redi-component-actions-bar">
        <Button
          active={editing}
          className="hotkeys-edit"
          bsStyle={editing ? 'warning' : bsStyle}
          bsSize={bsSize}
          onClick={handleEdit}>
          {editing ? 'Editing...' : 'Edit'}
        </Button>

        <TopTooltip content="Generate customizable report">
          <Button
            href={`/properties/${property.get('id')}/report`}
            target="_blank"
            bsStyle={bsStyle}
            bsSize={bsSize}>
            Property report w/transaction summaries
          </Button>
        </TopTooltip>

        {isPrivate &&
          <EmailRecordModal
            recordId={property.get('id')}
          />
        }

        {!isPrivate && !isAdmin &&
          <FlagRecordModal
            recordId={property.get('id')}
          />
        }
      </div>
    )
  }
}

export default PropertyActions



// WEBPACK FOOTER //
// ./modules/shared/pages/record/propertyActions.js